import { Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { WriteupModuleContext } from '@/store/writeup';
import { DealType } from '@/types/writeup';
import { DealTypeSelector } from '@/components/deal-type-selector';
import { DealTypeSelectorProps, DealTypeValue } from '@/components/deal-type-selector/types';
import { CoreModuleContext } from '@/store/core';

export class DealTypeSelectorContainer extends Vue.with(DealTypeSelectorProps) {
	@Inject() readonly i18n!: VueI18n;

	@Inject() readonly writeupModule!: WriteupModuleContext;

	@Inject() readonly coreModule!: CoreModuleContext;

	get writeup() { return this.writeupModule.getters.writeupObject; }

	get isWriteupUpdating() { return this.writeupModule.getters.isWriteupUpdating; }

	get dealType() { return this.writeupModule.getters.dealType; }

	get dealTypeSelectorValues(): DealTypeValue[] {
		const basicTypes = ['loan', 'cash'];

		if (this?.writeup?.leaseAvailable) { basicTypes.unshift('lease'); }

		return basicTypes.map(type => ({
			type: type as DealType,
			value: this.getValueByType(type as DealType),
		}));
	}

	async handleDealTypeChange(type: DealType) {
		await this.writeupModule.actions.changeDealType(type);
	}

	getValueByType(type: DealType) {
		if (!this.writeup || type !== this.writeup.type || type !== this.dealType) { return undefined; }

		return Math.ceil(type === DealType.cash ? this.writeup.pricing.totalPrice : this.writeup.pricing.monthly);
	}

	render() {
		return (
			<DealTypeSelector
				staticBar={ this.staticBar }
				values={ this.dealTypeSelectorValues }
				active={ this.dealType }
				loading={ this.isWriteupUpdating }
				onTypeChange={ this.handleDealTypeChange }
			/>
		);
	}
}
